import { cn } from "@/lib/utils";
import {
  TIME_RANGE_KEYS,
  TIME_RANGE_LABEL,
  type TimeRangeKey,
} from "@colab/shared";

const SHORT_LABEL: Record<TimeRangeKey, string> = {
  "7d": "7d",
  "30d": "30d",
  "90d": "90d",
  all: "All",
};

// Controlled component — the page wires URL sync (via react-router
// useSearchParams). Kept routerless so admin sub-bucket 10 can mount the
// same selector with a different state source (e.g. local component state
// for a modal preview).
export function TimeRangeSelector({
  value,
  onChange,
}: {
  value: TimeRangeKey;
  onChange: (next: TimeRangeKey) => void;
}) {
  return (
    <div
      role="group"
      aria-label="Time range"
      className="inline-flex rounded-md border bg-card p-0.5 text-xs"
    >
      {TIME_RANGE_KEYS.map((key) => {
        const active = key === value;
        return (
          <button
            key={key}
            type="button"
            onClick={() => {
              if (key !== value) onChange(key);
            }}
            title={TIME_RANGE_LABEL[key]}
            className={cn(
              "rounded px-2.5 py-1 font-medium transition",
              active
                ? "bg-foreground text-background"
                : "text-muted-foreground hover:bg-muted",
            )}
            aria-pressed={active}
          >
            {SHORT_LABEL[key]}
          </button>
        );
      })}
    </div>
  );
}
